// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__qZv+U","fixedLoader":"loader_fixedLoader__cjUM3","saveLoader":"loader_saveLoader__E0fIZ","loaderImage":"loader_loaderImage__UXtzo"};